<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
            <el-form-item label="操作人" prop="updatedBy">
              <el-input v-model="searchForm.updatedBy" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="操作时间">
              <form-date-range
                :form="searchForm"
                startKey="updatedDateStart"
                :usingTime="false"
                endKey="updatedDateEnd"
                valueFormat="yyyyMMdd"
              />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button size="small" type="primary" @click="handleAdd">新增</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="lifeCycle" label="生效周期" show-overflow-tooltip  align="center"></el-table-column>
          <el-table-column prop="updatedBy" label="操作人" show-overflow-tooltip  align="center"></el-table-column>
          <el-table-column prop="updatedDate" label="操作时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="{row}">
              <el-link type="primary" :underline="false" @click="handleEdit(row)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)" style="margin-left: 10px;">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <!-- 新增/编辑弹窗 -->
    <edit-dialog
      ref="editRef"
      v-if="isShowEditDialog"
      :visible.sync="isShowEditDialog"
      :editData="editData"
      :isEdit="isEdit"
      @saveSuccess="onSearch"
    />
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin';
import moment from 'moment';
import editDialog from "./components/edit-dialog.vue";

export default {
  mixins: [tableMixin, pagePathMixin],
  components: {
    editDialog
  },
  data() {
    return {
      searchForm: {
        updatedBy: "",
        updatedDateStart: "",
        updatedDateEnd: "",
      },
      // 表格相关
      tableData: [],
      pageSize: 50,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      // 弹窗相关
      isShowEditDialog: false,
      isEdit: false,
      editData: {}
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure.querySaleTargetList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.updatedDateStart = "";
      this.searchForm.updatedDateEnd = "";
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd() {
      this.isEdit = false;
      this.editData = {};
      this.isShowEditDialog = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.editData = { ...row };
      this.isShowEditDialog = true;
    },
    handleDelete(row) {
      console.log("🚀 ~ row:", row)
      this.$confirm('确定要删除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.configure.deleteSaleTarget(row.id)
          .then(() => {
            this.$message.success('删除成功');
            this.onSearch();
          });
      }).catch(() => {});
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
</style>
